"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LogLevel = void 0;
exports.LogLevel = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    NONE: 4,
};
class Logger {
    constructor(options) {
        var _a;
        this.prefix = options.prefix;
        this.logLevel = (_a = options.logLevel) !== null && _a !== void 0 ? _a : exports.LogLevel.ERROR;
        this.initTime = Date.now();
    }
    setLogLevel(logLevel) {
        this.logLevel = logLevel;
    }
    debug(...args) {
        if (this.logLevel <= exports.LogLevel.DEBUG) {
            console.debug(this.prefix, ...args, Date.now() - this.initTime);
        }
    }
    info(...args) {
        if (this.logLevel <= exports.LogLevel.INFO) {
            console.info(this.prefix, ...args);
        }
    }
    warn(...args) {
        if (this.logLevel <= exports.LogLevel.WARN) {
            console.warn(this.prefix, ...args);
        }
    }
    error(...args) {
        if (this.logLevel <= exports.LogLevel.ERROR) {
            console.error(this.prefix, ...args);
        }
    }
}
exports.Logger = Logger;
//# sourceMappingURL=Logger.js.map